import axios, { AxiosHeaders } from "axios"
import { AccessDeniedError, StandardError } from "./StandardError"

export const Http = {
    postJson: postJson,
    get: get,
}

// Post JSON and expect JSON back
// Throws exception on error
export async function postJson<T>(
    url: string,
    data: unknown,
    inputHeaders: Record<string, unknown>,
    allowNoContent: true,
): Promise<T | { [k: string]: never }>
export async function postJson<T>(
    url: string,
    data: unknown,
    inputHeaders?: Record<string, unknown>,
    allowNoContent?: false,
): Promise<T>
export async function postJson<T>(
    url: string,
    data: unknown,
    inputHeaders: Record<string, unknown> = {},
    allowNoContent = false,
): Promise<T | { [k: string]: never }> {
    const headers = new AxiosHeaders({ "Content-Type": "application/json" })

    for (const [key, value] of Object.entries(inputHeaders)) {
        headers[key] = value
    }

    const response = await axios.post<T>(url, data, { headers })

    if (response.status === 204 && allowNoContent) return {}
    if (response.status === 201 && allowNoContent) return {}
    if (response.status === 401) throw new AccessDeniedError()
    if (response.status !== 200) throw new StandardError("Error when calling " + url + ": " + response.statusText)

    return response.data
}

export async function get<T>(
    url: string,
    queryParameters?: { [key: string]: string | number },
    inputHeaders: Record<string, unknown> = {},
): Promise<T> {
    const headers = new AxiosHeaders({ "Content-Type": "application/json" })

    for (const [key, value] of Object.entries(inputHeaders)) {
        headers[key] = value
    }

    const response = await axios.get(url, {
        headers,
        params: queryParameters,
    })

    if (response.status !== 200) throw new StandardError("Error when calling " + url + ": " + response.statusText)

    return response.data
}
